import { atom } from "jotai";

export default atom(true);
